import ky from "ky";
import EventBus from "../../events/EventBus";

const keycloakClient = ky.extend({
    prefixUrl: process.env.REACT_APP_KEYCLOAK_URL,
    hooks: {
        beforeRequest: [
            request => {
                // Do something before every request
                // good place to authorize request if needed
                // request.headers.set('X-Requested-With', 'ky');
                // request.headers.set('content-type', 'application/json');
            }
        ],
        beforeError: [
            error => {
                const { response } = error;
                if (response && response.body) {
                    error.name = 'GitHubError';
                    error.message = `${response.body.message} (${response.status})`;
                }
                return error;
            }
        ],
        beforeRetry: [
            async ({request, options, error, retryCount}) => {
                const token = await ky('https://localhost/refresh-token')
                request.headers.set('Authorization', `token ${token}`);
            }
        ],
        afterResponse: [
            (_request, _options, response) => {
                // Do something after every response
                // check status code
                // console.log(response);
                if (response && response.status === 401) {
                    EventBus.dispatch("token-expired")
                }
                return new Response(response.body, {status: response.status});
            }
        ]
    }
})

export default keycloakClient